import { z } from "zod";
import { IsoDateTimeSchema } from "./common.js";

export const ManagerWorkStateSchema = z.enum([
	"NOT_STARTED",
	"RUNNING",
	"AWAITING_REVIEW",
	"BLOCKED",
	"COMPLETED",
	"FAILED",
]);
export const NextActorSchema = z.enum(["ASSIGNEE", "MANAGER", "USER", "EXTERNAL", "NONE"]);
export const ProgressWaitReasonSchema = z.enum([
	"APPROVAL",
	"USER_RESPONSE",
	"EXTERNAL_EVENT",
	"EXPLICIT_BLOCK",
]);
export const AttentionStateSchema = z.enum(["NONE", "OPEN", "ACKNOWLEDGED"]);

export const ManagerProgressItemSchema = z
	.object({
		workId: z.string().min(1),
		parentWorkId: z.string().min(1).nullable(),
		name: z.string().min(1),
		assignee: z.string().min(1),
		state: ManagerWorkStateSchema,
		lastProgressAt: IsoDateTimeSchema,
		elapsedMs: z.number().int().nonnegative(),
		allowedNoProgressMs: z.number().int().positive(),
		blockReason: z.string().min(1).nullable(),
		waitReason: ProgressWaitReasonSchema.nullable(),
		nextActor: NextActorSchema,
		attention: AttentionStateSchema,
		attentionIntervalId: z.string().min(1).nullable(),
		lastCheckedAt: IsoDateTimeSchema.nullable(),
		resolvedAt: IsoDateTimeSchema.nullable(),
		resolutionProgressAt: IsoDateTimeSchema.nullable(),
	})
	.strict();

export const ManagerProgressBoardSchema = z
	.object({
		projectId: z.string().min(1),
		items: z.array(ManagerProgressItemSchema),
		watchdog: z.object({
			lastSuccessfulTickAt: IsoDateTimeSchema.nullable(),
			lastFailureAt: IsoDateTimeSchema.nullable(),
			lastFailureCode: z.string().min(1).nullable(),
		}),
	})
	.strict();

export const ManagerAttentionActionRequestSchema = z
	.object({
		action: z.enum(["ACKNOWLEDGE", "REQUEST_RECHECK", "REQUEST_RETRY"]),
		reason: z.string().min(1).max(1000),
	})
	.strict();

export const ManagerAttentionActionResponseSchema = z
	.object({
		accepted: z.literal(true),
		action: ManagerAttentionActionRequestSchema.shape.action,
		workId: z.string().min(1),
	})
	.strict();

export type ManagerProgressItem = z.infer<typeof ManagerProgressItemSchema>;
export type ManagerProgressBoard = z.infer<typeof ManagerProgressBoardSchema>;
export type ManagerAttentionActionRequest = z.infer<typeof ManagerAttentionActionRequestSchema>;
export type ManagerAttentionActionResponse = z.infer<typeof ManagerAttentionActionResponseSchema>;
